"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const emotion_1 = require("emotion");
const colors_1 = require("./colors");
const utils_1 = require("./utils");
const isSelectionTruthy = value => !((Array.isArray(value) && !value.length) || (value === null || value === undefined || value === ''));
const noop = () => { };
const SelectWrapper = props => {
    const { value, containerClassName, placeholder, label, selectedSelect, required, helpText, onBlurResetsInput, status, onBlur = noop, onFocus = noop, id, } = props;
    const [shouldFloat, setShouldFloat] = react_1.useState(value);
    const labelId = utils_1.useMemoizedId({ label: 'react-select', id });
    const handleFocus = () => {
        setShouldFloat(true);
        onFocus();
    };
    const handleBlur = event => {
        const target = event && event.target;
        if ((onBlurResetsInput === false && target && target.value) || isSelectionTruthy(value)) {
            setShouldFloat(true);
        }
        else {
            setShouldFloat(false);
        }
        onBlur();
    };
    const handleInputKeyDown = searchInput => {
        if (searchInput !== '') {
            setShouldFloat(true);
        }
    };
    react_1.useEffect(() => {
        setShouldFloat(isSelectionTruthy(value));
    }, [value]);
    const className = emotion_1.cx('react-select-wrapper form-group', containerClassName, { 'form-group-active': shouldFloat });
    const helpTextClassName = status === 'error' ? 'text-danger' : `text-${status}`;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("label", { htmlFor: labelId, style: { pointerEvents: 'none', wordWrap: 'break-word', width: '80%' }, className: 'control-label', title: placeholder || label },
            placeholder || label,
            required ? react_1.default.createElement("span", { style: { color: colors_1.persimmon.base } }, " *") : ''),
        react_1.default.createElement(selectedSelect, Object.assign(Object.assign({}, props), { inputId: labelId, onFocus: handleFocus, onBlur: handleBlur, onInputChange: handleInputKeyDown, placeholder: '' })),
        helpText ? react_1.default.createElement("small", { className: helpTextClassName }, helpText) : null));
};
SelectWrapper.propTypes = {
    containerClassName: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    selectedSelect: prop_types_1.default.func,
    label: prop_types_1.default.node,
    placeholder: prop_types_1.default.node,
    value: prop_types_1.default.any,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    helpText: prop_types_1.default.node,
    onBlurResetsInput: prop_types_1.default.bool,
    status: prop_types_1.default.oneOf(['success', 'warning', 'error']),
    id: prop_types_1.default.string,
};
exports.default = SelectWrapper;
